export default __webpack_public_path__ + "static/media/sq.c7c76c14.jpg";